import React from 'react';
import { NavLink } from 'react-router-dom';
import { BsSun } from 'react-icons/bs';

const Header = ({radius}) => {

    return (
        <header className='header'>
            <NavLink exact to='/'><BsSun className='logo' size='40'/></NavLink>
                <NavLink exact to='/' className='profile-nav' style={{borderRadius: `${radius}px`}}>Portfolio</NavLink>
                <NavLink to='/about' className='about-nav' style={{borderRadius: `${radius}px`}}>About</NavLink>
                <NavLink to='/contact' className='contact-nav' style={{borderRadius: `${radius}px`}}>Contact</NavLink>
        </header>
    )
}

export default Header;
